import react from "react";
import Channel from "../components/Channel";


export default function Home(){
    return(
        <>
        <Channel />
        </>
    )
}